module.exports = __webpack_public_path__ + "ef2f2b4a2eee8775d59f4bcbabc8778f.svg";